import React, { useContext, useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useSelector } from 'react-redux';

const SchemaModal = (props) => {
    const { t } = useTranslation();
    const { openModal, okHandler, handleClose, connection, schema, setSchema } = props;
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const currentTab = rightTree.currentTab;
    const translatedData = rightTree.tree[currentTab].translatedData;
    const selectedNode = rightTree.tree[currentTab].selectedNode;
    const pdc = useSelector((state) => state.treeData[parentScreen].pdc);
    const [schemaOptions, setSchemaOptions] = useState([]);



    const handleChange = (value) => {
        setSchema(value);
    }

    useEffect(() => {
        const schemas = Object.keys(pdc?.[connection] || {});
        if (schemas?.length && connection) {
            setSchemaOptions(
                schemas?.filter((e) => e)
                    ?.map((e, i) => {
                        return (
                            <MenuItem value={e} key={i}>
                                {e}
                            </MenuItem>
                        );
                    }) || []
            )
        }

    }, [pdc, connection]);

    useEffect(() => {
        setSchema(selectedNode?.SCHEMA || '')
    }, [selectedNode?.key])



    return (
        <Dialog
            open={openModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle className='dialog-header'>
                {t('SCHEMA_MODAL_DESC')}
            </DialogTitle>

            <DialogContent className='modal-content' dividers>
                <FormControl className='width-100'>
                    <InputLabel>{t('LBL_SHCEMA')}</InputLabel>
                    <Select
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxHeight: 300,
                                },
                            },
                        }}
                        value={schema}
                        size="small"
                        onChange={(e) => handleChange(e.target.value)}
                    >
                        {schemaOptions}
                    </Select>
                </FormControl>

            </DialogContent>

            <DialogActions>
                <Button
                    disabled={!schema}
                    size="small"
                    onClick={() => okHandler(schema)}
                    variant={"outlined"}
                >
                    {t("BTN_OK")}
                </Button>
                <Button
                    size="small"
                    onClick={handleClose}
                    variant={"outlined"}
                >
                    {t("CANCEL")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default SchemaModal